import React, { useEffect, useState, useRef } from "react";
import CountUp from "react-countup";
import { API_URL } from "../App.js";
import { UsersIcon, DocumentTextIcon, CodeBracketIcon, LightBulbIcon } from "@heroicons/react/24/solid";

function StatsCounter(props) {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState(null);
  const targetRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const isVisible = entries[0].isIntersecting;
        if (isVisible) {
          setIsVisible(true);
        }
      },
      {
        rootMargin: "0px",
        threshold: 0.5,
      }
    );

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    fetch(API_URL + "statistics")
      .then((response) => response.json())
      .then((data) => {
        setData(data.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="mt-4 mb-4" ref={targetRef}>
      {isVisible && (
        <div className="bg-colorPrincipal py-4 px-4">
          <div className="container mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {/* Integrantes */}
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 transform hover:scale-105 transition-all duration-300 hover:bg-white/20">
                <h4 className="text-white font-sans tracking-wide text-sm mb-2 text-center uppercase">
                  Integrantes
                </h4>
                <div className="flex items-center justify-center gap-4">
                  <UsersIcon className="w-12 h-12 text-white/90" />
                  <h1 className="text-5xl font-extrabold font-sans text-white">
                    <CountUp
                      start={0}
                      end={data?.integrantes_count || 0}
                      duration={5}
                    />
                  </h1>
                </div>
              </div>

              {/* Publicaciones */}
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 transform hover:scale-105 transition-all duration-300 hover:bg-white/20">
                <h4 className="text-white font-sans tracking-wide text-sm mb-2 text-center uppercase">
                  Publicaciones
                </h4>
                <div className="flex items-center justify-center gap-4">
                  <DocumentTextIcon className="w-12 h-12 text-white/90" />
                  <h1 className="text-5xl font-extrabold font-sans text-white">
                    <CountUp
                      start={0}
                      end={data?.publicacion_count || 0}
                      duration={5}
                    />
                  </h1>
                </div>
              </div>

              {/* Software */}
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 transform hover:scale-105 transition-all duration-300 hover:bg-white/20">
                <h4 className="text-white font-sans tracking-wide text-sm mb-2 text-center uppercase">
                  Software
                </h4>
                <div className="flex items-center justify-center gap-4">
                  <CodeBracketIcon className="w-12 h-12 text-white/90" />
                  <h1 className="text-5xl font-extrabold font-sans text-white">
                    <CountUp
                      start={0}
                      end={data?.software_count || 0}
                      duration={5}
                    />
                  </h1>
                </div>
              </div>

              {/* Proyectos */}
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 transform hover:scale-105 transition-all duration-300 hover:bg-white/20">
                <h4 className="text-white font-sans tracking-wide text-sm mb-2 text-center uppercase">
                  Proyectos
                </h4>
                <div className="flex items-center justify-center gap-4">
                  <LightBulbIcon className="w-12 h-12 text-white/90" />
                  <h1 className="text-5xl font-extrabold font-sans text-white">
                    <CountUp
                      start={0}
                      end={data?.proyecto_count || 0}
                      duration={5}
                    />
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default StatsCounter;
